export default __webpack_public_path__ + "static/media/banner-aa-tay-ninh.70e1ff0c.png";